<template>
  <!--  -->
  <v-navigation-drawer
    app dark touchless
    v-model="drawer"
    fixed
    height="100%"
    temporary
    width="300"
    v-if="$vuetify.breakpoint.xsOnly"
  >
    <v-toolbar dark
    v-if="$vuetify.breakpoint.mdAndUp"
    >
      <v-toolbar-title class="text-center">
        <div :class="mini ? 'drawer-logo-wrap drawer-logo-wrap-mini' : 'drawer-logo-wrap'">
          <img :src="logoPrimary" alt="Logo" />
        </div>
      </v-toolbar-title>
      <v-spacer></v-spacer>
      <v-btn
        class="drawer-toggle-btn"
        icon
        aria-label="Close navigation drawer"
        @click.stop="$emit('toggleDrawer')"
      >
        <v-icon>mdi-chevron-left</v-icon>
      </v-btn>
    </v-toolbar>

    <nav-list :singleMenus="singleMenuList" :groupMenus="groupMenuList"></nav-list>

  </v-navigation-drawer>
  <v-navigation-drawer
    app dark touchless
    v-model="drawer"
    :mini-variant.sync="mini"
    :mini-variant-width="$vuetify.breakpoint.xsOnly ? '50' : '80'"
    :clipped="$vuetify.breakpoint.xsOnly"
    :expand-on-hover="$vuetify.breakpoint.xsOnly"
    permanent
    width="300"
    v-else
  >
    <v-toolbar dark
    v-if="$vuetify.breakpoint.mdAndUp"
    >
      <v-toolbar-title class="text-center">
        <div :class="mini ? 'drawer-logo-wrap drawer-logo-wrap-mini' : 'drawer-logo-wrap'">
          <img :src="logoPrimary" alt="Logo" />
        </div>
      </v-toolbar-title>
      <v-spacer></v-spacer>
        <v-btn
          v-if="!mini"
          class="drawer-toggle-btn"
          icon
          aria-label="Collapse navigation drawer"
          @click.stop="mini = !mini"
        >
          <v-icon>mdi-chevron-left</v-icon>
        </v-btn>
    </v-toolbar>

    <nav-list :singleMenus="singleMenuList" :groupMenus="groupMenuList"></nav-list>

  </v-navigation-drawer>
</template>

<script>
import { mapState } from 'vuex';
import NavList from './DrawerNavList';

export default {
  name: 'CoreDrawer',
  components: { NavList },
  props: [
    'drawer'
  ],
  data() {
    return {
      mini: true,
      logoPrimary: require('@/assets/Kobe Logo Green.png')
    };
  },
  computed: {
    ...mapState(['user', 'globalConfig']),
    singleMenuList() {
      // filter on sub menus
      let singleMenus = this.globalConfig.singleNavMenu.map(smenu => {
        if (smenu.subMenus) {
          smenu.subMenus = smenu.subMenus.filter(subMenu => subMenu.permissions.includes(this.user.role))
        }
        return smenu
      });
      // filter on main single menu
      return singleMenus.filter(smenu => smenu.permissions.includes(this.user.role));
    },
    groupMenuList() {
      const groupNavMenuConfig = this.globalConfig.groupNavMenu;
      var userRole = this.user.role;
      var result = []
      groupNavMenuConfig.forEach(groupItem => {
        var newSubMenus = []
        groupItem.subMenus.forEach(subMenuItem => {
          if (subMenuItem.permissions.includes(userRole)) {
            newSubMenus.push(subMenuItem)
          }
        })
        if (newSubMenus.length > 0) {
          var newGroupItem = {}
          newGroupItem.name = groupItem.name
          newGroupItem.icon = groupItem.icon
          newGroupItem.subMenus = newSubMenus
          result.push(newGroupItem)
        }
      });
      return result;
    }
  }
};
</script>

<style scoped>
.drawer-logo-wrap {
  width: 126px;
  max-width: 100%;
  line-height: 0;
  padding: 4px 0;
}

.drawer-logo-wrap-mini {
  width: 52px;
}

.drawer-logo-wrap img {
  display: block;
  width: 100%;
  height: auto;
}
</style>



// WEBPACK FOOTER //
// Drawer.vue?1994b06a